import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const TitleBar = ({ title, subtitle, children }) => (
  <div className={styles['container']}>
    {title && (
      <div>
        <h1 className={styles['title']}>{title}</h1>
        {subtitle && <div className={styles['subtitle']}>{subtitle}</div>}
      </div>
    )}
    {children}
  </div>
);

TitleBar.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default TitleBar;



// WEBPACK FOOTER //
// ./src/common/components/Layout/TitleBar/index.js